import { authHeaders, requestJson } from './http';
const base = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';
export interface HouseholdPlan {
  product_key: string; name: string; amount_minor: number; currency: string;
  commercial_terms_version?: string; rollover_max_units?: number | null; retention_months?: number | null;
  interval: 'month'; allowance_units: number; rollover_policy: string;
  grace_days: number; grace_creation?: boolean; grace_playback?: boolean; retention_terms: string; is_test: boolean; test_fixture?: boolean;
}
export interface BillingView {
  enabled: boolean; can_checkout: boolean; checkout_enabled: boolean; management_enabled: boolean;
  plans: HouseholdPlan[];
  order?: { id: string; status: string } | null;
  subscription: null | {
    id: string; status: string; plan: HouseholdPlan;
    current_period_start: string | null; current_period_end: string | null;
    cancel_at_period_end: boolean; cancellation_allowed?: boolean; grace_until: string | null;
    allowance: { granted: number; consumed: number; remaining: number; capped_units?: number; expiring?: { units: number; expires_at: string }[] };
    first_failure_at?: string | null;
    retention?: { render_id: string; title: string; retained_until: string; notice_due_at: string | null; notice_status: string; state: string }[];
    recovery_pending: boolean; creation_allowed?: boolean; access_expires_at?: string | null;
  };
}
function path(id: string) { return `${base}/households/${encodeURIComponent(id)}/billing`; }
export function fetchBilling(id: string, signal?: AbortSignal) {
  return requestJson<BillingView>(path(id), { headers: authHeaders(), signal });
}
export function startSubscriptionCheckout(id: string, product_key: string, idempotency_key: string) {
  return requestJson<{ order_id: string; status: string; checkout_url: string | null }>(`${path(id)}/checkout`, {
    method: 'POST', headers: authHeaders(true), body: JSON.stringify({ product_key, idempotency_key }),
  });
}
export function manageSubscriptionPayment(id: string) {
  return requestJson<{ url: string }>(`${path(id)}/portal`, { method: 'POST', headers: authHeaders(true) });
}
export function changeSubscription(id: string, action: 'cancel' | 'reactivate', idempotency_key: string) {
  return requestJson<BillingView>(`${path(id)}/${action}`, { method: 'POST', headers: authHeaders(true), body: JSON.stringify({ idempotency_key }) });
}
export function hostedBillingUrl(value: string): string {
  const url = new URL(value);
  if (url.protocol !== 'https:' || !['checkout.stripe.com', 'billing.stripe.com'].includes(url.hostname)) throw new Error('Invalid hosted billing URL');
  return url.href;
}

export function deleteRetainedContent(renderId: string) {
  return requestJson<unknown>(`${base}/renders/${encodeURIComponent(renderId)}/retained-content`, { method: 'DELETE', headers: authHeaders() });
}
